import React, { Fragment, useEffect, useState } from "react";

import { Switch, Chip, IconButton } from "@material-ui/core/";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons/";

import NavBar from "../../components/NavBar";
import PageHeader from "../../components/PageHeader";
import PageScreen from "../../components/PageScreen";
import DataView from "../../components/DataView";
import RightModal from "../../components/RightModal/v2";

import { useConfirm } from "material-ui-confirm";

import { Link, useParams } from "react-router-dom";

// HOCs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modulesActionCreators from "../../data/modules/actions";
import HeaderButton from "../../components/HeaderButton";

import Moment from "react-moment";
import "moment-timezone";
import nativeMoment from "moment-timezone";
import "moment/locale/es";

const BASE_QUERY = {
  $limit: 10,
  $sort: { position: 1 }
};

const Games = (props) => {


  const MODAL_MANIFEST = [
    [
      {
        key: "icon",
        type: "string",
        label: "Icono",
        help: "Icono del juego",
      }
    ],
    [
      {
        key: "color",
        type: "string",
        label: "Color",
        help: "Color del juego",
      },
    ],
    [
      {
        key: "active",
        type: "switch",
        label: "Activo",
        help: "Mostrar u ocultar el juego en la app",
      },
    ],
    [
      {
        key: "title",
        multilang: true,
        type: "string",
        label: "Título",
        help: "Título del juego.",
      },
    ],
    [
      {
        key: "totalTime",
        type: "string",
        label: "Tiempo total",
        help: "Tiempo total en segundos para completar el juego",
      },
      {
        key: "pointsPerSecond",
        type: "string",
        label: "Puntos por segundo",
        help: "Puntos otorgados por cada segundo que sobre",
      },
    ],
    [
      {
        key: "questions",
        type: "nested",
        label: "Preguntas",
        add: "Añadir pregunta",
        children: [
          [
            {
              key: "title",
              multilang: true,
              type: "string",
              label: "Título",
              help: "Título de la pregunta",
            }
          ],
          [
            {
              key: "type",
              type: "select",
              label: "Tipo",
              help: "Tipo de pregunta",
              options: [
                { key: 'options', label: 'Opciones' },
                { key: 'options', label: 'Opciones' },
              ]
            }
          ],
          [
            {
              key: "options",
              type: "nested",
              label: "Opciones",
              add: "Añadir opción",
              children: [
                [
                  {
                    key: "title",
                    multilang: true,
                    type: "string",
                    label: "Título",
                    help: "Título de la opción",
                  }
                ],
                [
                  {
                    key: "correct",
                    type: "switch",
                    label: "Opción correcta",
                  },
                  {
                    key: "points",
                    type: "string",
                    label: "Puntos",
                    help: "Puntos de la respuesta",
                  }
                ],
              ]
            }
          ]
        ]
      },
    ],
  ];
  const MODAL_LANG_MANIFEST = [

  ];

  let { moduleId } = useParams();

  useEffect(() => {
    props.actions.modules.getItem(moduleId);
  }, []);

  const [currentItem, setCurrentItem] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const handleNew = () => {
    setCurrentItem({
      icon: 'question-mark-circle',
      color: '#FF9281'
    });
    setModalOpen(true);
  };

  const handleEdit = (item) => {
    const newItem = { ...item };

    setCurrentItem(newItem);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setCurrentItem({});
  };

  const confirm = useConfirm();

  return (
    <Fragment>
      <NavBar
        crumbs={[
          { title: "Apps", path: "/" },
          { title: props.selectedApp.name, path: `/${props.selectedApp.slug}` },
          { title: props.modules.selectedItem.name },
        ]}
      />
      <PageScreen className="ListPage">
        <PageHeader
          title={props.modules.selectedItem.name}
          renderActions={() => (
            <Fragment>
              <HeaderButton onClick={handleNew}>+ Nuevo juego</HeaderButton>
            </Fragment>
          )}
        />
        <DataView
          items={(props.modules.selectedItem.games||[]).sort( (a,b) => a.position > b.position ? 1 : -1)}
          columnDefs={[
            { ref: "title", align: "left" },
            { ref: "active", align: "left" },
            { ref: "questions", align: "left" },
            { ref: "actions", align: "left" },
          ]}
          renderHeader={(ref) => {
            switch (ref) {
              case "title":
                return "Título";
              case "active":
                return "Activo";
              case "questions":
                return "Preguntas";
              case "actions":
                return "Acciones";
              default:
                return null;
            }
          }}
          renderCell={(ref, item) => {
            switch (ref) {
              case "title":
                return item[ref][props.defaultLang];
              case "active":
                return (
                  <Switch
                    color="primary"
                    name="checkedA"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                    onChange={(event) =>
                      props.actions.modules.patchGame(moduleId, {
                        ...item,
                        active: event.target.checked,
                      })
                    }
                    checked={item.active}
                  />
                );
              case "questions":
                return item.questions.length;
              case "actions":
                return (
                  <Fragment>
                    <IconButton
                      size="small"
                      aria-label="delete"
                      className="EditButton"
                      onClick={() => handleEdit(item)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      aria-label="delete"
                      className="DeleteButton"
                      onClick={() => {
                        confirm({
                          title: "¿Eliminar juego?",
                          description: `Esta acción eliminará por completo el
                          juego.
                          Esta acción es permenente y no tiene marcha atrás.`,
                          confirmationText: "Eliminar",
                          confirmationButtonProps: { variant: "contained" },
                          cancellationText: "Cancelar",
                          cancellationButtonProps: { variant: "contained" },
                        })
                          .then(() => {
                            props.actions.modules.removeGame(moduleId, item._id);
                          })
                          .catch(() => {});
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Fragment>
                );
              default:
                return null;
            }
          }}
          empty={{
            title: "Añade juegos a tu gamificación",
            body:
              "Construye rápidamente y previsualiza al instante todas las funciones están incluidas, solo cree y publique go live en minutos y comience a incorporar asistentes",
            cta: "+ Crear nuevo juego",
            action: handleNew,
          }}
        />
      </PageScreen>
      <RightModal
        newTitle="Crear juego"
        editTitle="Editar juego"
        open={modalOpen}
        currentItem={currentItem}
        handleClose={handleClose}
        manifest={MODAL_MANIFEST}
        langManifest={MODAL_LANG_MANIFEST}
        createAction={(payload) => {
          console.log("PAYLOAD", payload)
          return props.actions.modules.createGame(moduleId, payload)
        }}
        patchAction={(currentItem, payload) =>
          props.actions.modules.patchGame(moduleId, payload)
        }
      />
    </Fragment>
  );
};

export default connect(
  (state, ownProps) => ({
    selectedApp: state.data.apps.selected,
    modules: state.data.modules,
    services: {
      app: state.services.app
    },
    defaultLang: 'es'
  }),
  (dispatch) => ({
    actions: {
      modules: bindActionCreators(modulesActionCreators, dispatch),
    },
  })
)(Games);
